(() => {
  const activateTabs = (root) => {
    root.querySelectorAll('[data-sofa-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.sofaTab
        root.querySelectorAll('[data-sofa-tab]').forEach((button) => {
          const selected = button === tab
          button.classList.toggle('is-active', selected)
          button.setAttribute('aria-selected', selected ? 'true' : 'false')
        })
        root.querySelectorAll('[data-sofa-panel]').forEach((panel) => {
          const selected = panel.dataset.sofaPanel === target
          panel.classList.toggle('is-active', selected)
          panel.hidden = !selected
        })
      })
    })
  }

  const init = () => document.querySelectorAll('[data-sofa-finder]').forEach(activateTabs)
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init()
})()
